import { Vector3 } from "three";
import { HighLevelJoint } from "types/stl";

export const HighHeelHeight: HighLevelJoint = {
  vertices: [
    {
      ids: [
        1770,
      ],
      weight: 0.93
    },
    {
      ids: [
        1244,
        1768,
        1769,
        1771,
        1772,
        1773,
      ],
      weight: 0.92
    },
    {
      ids: [
        1232,
        1233,
        1234,
        1235,
        1236,
        1237,
        1241,
        1242,
        1243,
        1245,
        1246,
        1247,
        1248,
        1256,
        1257,
        1258,
        1260,
        1266,
        1267,
        1320,
        1321,
        1322,
        1329,
        1330,
        1764,
        1765,
        1767,
      ],
      weight: 0.91
    },
    {
      ids: [
        1238,
        1239,
        1240,
        1249,
        1250,
        1251,
        1252,
        1253,
        1254,
        1255,
        1259,
        1261,
        1262,
        1263,
        1264,
        1268,
        1269,
        1270,
        1317,
        1318,
        1319,
        1324,
        1325,
        1326,
        1327,
        1328,
        1762,
        1763,
        1766,
      ],
      weight: 0.9
    },
    {
      ids: [
        1265,
        1271,
        1272,
        1273,
        1275,
        1276,
        1277,
        1278,
        1286,
        1287,
        1323,
        1331,
        1332,
        1333,
        1334,
        1336,
        1361,
        1362,
        1369,
        1370,
        1447,
        1450,
        1452,
        1456,
        1457,
        1462,
        1503,
      ],
      weight: 0.89
    },
    {
      ids: [
        1274,
        1279,
        1280,
        1282,
        1283,
        1284,
        1288,
        1296,
        1335,
        1357,
        1359,
        1360,
        1364,
        1365,
        1368,
        1371,
        1448,
        1449,
        1451,
        1458,
        1461,
        1465,
        1467,
        1498,
        1501,
        1758,
        1759,
        1761,
      ],
      weight: 0.88
    },
    {
      ids: [
        1281,
        1285,
        1289,
        1290,
        1291,
        1295,
        1358,
        1363,
        1366,
        1367,
        1372,
        1376,
        1453,
        1454,
        1455,
        1459,
        1460,
        1463,
        1464,
        1466,
        1471,
        1474,
        1499,
        1500,
        1502,
        1507,
        1527,
      ],
      weight: 0.87
    },
    {
      ids: [
        246,
        248,
        304,
        306,
        324,
        325,
        326,
        1292,
        1293,
        1294,
        1297,
        1298,
        1306,
        1307,
        1373,
        1374,
        1375,
        1396,
        1397,
        1404,
        1405,
        1468,
        1469,
        1470,
        1472,
        1475,
        1477,
        1504,
        1505,
        1506,
        1509,
        1525,
        1526,
        1756,
        1757,
        1760,
      ],
      weight: 0.86
    },
    {
      ids: [
        238,
        240,
        244,
        245,
        247,
        249,
        295,
        298,
        305,
        307,
        308,
        314,
        315,
        316,
        317,
        318,
        319,
        320,
        1299,
        1300,
        1302,
        1303,
        1304,
        1308,
        1316,
        1392,
        1394,
        1395,
        1399,
        1400,
        1403,
        1406,
        1473,
        1476,
        1479,
        1480,
        1483,
        1508,
        1522,
        1524,
        1530,
        1531,
        1752,
        1753,
        1755,
      ],
      weight: 0.85
    },
    {
      ids: [
        206,
        207,
        208,
        235,
        236,
        237,
        239,
        242,
        243,
        250,
        251,
        252,
        284,
        285,
        286,
        296,
        297,
        299,
        300,
        301,
        302,
        311,
        312,
        313,
        321,
        322,
        323,
        327,
        328,
        329,
        1301,
        1305,
        1309,
        1310,
        1315,
        1393,
        1398,
        1401,
        1402,
        1407,
        1478,
        1481,
        1484,
        1486,
        1523,
        1529,
        1533,
        1548,
      ],
      weight: 0.84
    },
    {
      ids: [
        199,
        200,
        205,
        209,
        210,
        241,
        253,
        254,
        275,
        276,
        287,
        292,
        294,
        303,
        309,
        310,
        1121,
        1123,
        1128,
        1148,
        1151,
        1157,
        1172,
        1175,
        1177,
        1311,
        1312,
        1313,
        1337,
        1346,
        1408,
        1409,
        1411,
        1417,
        1425,
        1482,
        1485,
        1487,
        1489,
        1528,
        1532,
        1546,
        1547,
      ],
      weight: 0.83
    },
    {
      ids: [
        168,
        195,
        197,
        198,
        202,
        203,
        204,
        211,
        212,
        264,
        277,
        278,
        280,
        281,
        282,
        288,
        291,
        293,
        1118,
        1120,
        1122,
        1127,
        1129,
        1149,
        1150,
        1153,
        1158,
        1162,
        1173,
        1174,
        1176,
        1314,
        1338,
        1343,
        1347,
        1410,
        1416,
        1420,
        1424,
        1488,
        1491,
        1492,
        1543,
        1545,
        1551,
        1750,
        1751,
        1754,
      ],
      weight: 0.82
    },
    {
      ids: [
        166,
        167,
        169,
        196,
        201,
        213,
        214,
        265,
        266,
        274,
        279,
        283,
        289,
        290,
        1119,
        1126,
        1130,
        1132,
        1152,
        1154,
        1159,
        1161,
        1178,
        1179,
        1180,
        1205,
        1208,
        1217,
        1219,
        1339,
        1340,
        1344,
        1348,
        1356,
        1414,
        1415,
        1419,
        1423,
        1426,
        1490,
        1493,
        1495,
        1544,
        1550,
        1552,
      ],
      weight: 0.81
    },
    {
      ids: [
        159,
        160,
        165,
        170,
        172,
        255,
        256,
        267,
        272,
        273,
        1124,
        1125,
        1155,
        1156,
        1206,
        1207,
        1210,
        1214,
        1216,
        1218,
        1341,
        1342,
        1345,
        1355,
        1412,
        1413,
        1418,
        1427,
        1494,
        1496,
        1510,
        1549,
        1554,
        1560,
        1746,
        1747,
        1749,
      ],
      weight: 0.8
    },
    {
      ids: [
        155,
        157,
        158,
        162,
        163,
        164,
        171,
        257,
        258,
        260,
        261,
        262,
        268,
        271,
        1131,
        1160,
        1181,
        1190,
        1198,
        1202,
        1209,
        1211,
        1215,
        1222,
        1349,
        1350,
        1351,
        1353,
        1421,
        1422,
        1428,
        1431,
        1497,
        1511,
        1513,
        1553,
        1558,
        1559,
      ],
      weight: 0.79
    },
    {
      ids: [
        147,
        148,
        156,
        161,
        173,
        224,
        225,
        259,
        263,
        270,
        447,
        449,
        450,
        451,
        453,
        487,
        488,
        518,
        519,
        1182,
        1184,
        1192,
        1196,
        1197,
        1203,
        1212,
        1213,
        1220,
        1221,
        1352,
        1354,
        1377,
        1386,
        1429,
        1430,
        1437,
        1443,
        1512,
        1515,
        1516,
        1555,
        1557,
        1563,
      ],
      weight: 0.78
    },
    {
      ids: [
        38,
        40,
        59,
        61,
        140,
        146,
        149,
        150,
        174,
        215,
        226,
        232,
        234,
        269,
        489,
        517,
        1183,
        1186,
        1191,
        1193,
        1195,
        1204,
        1378,
        1383,
        1387,
        1436,
        1440,
        1442,
        1514,
        1517,
        1519,
        1556,
        1562,
        1564,
        1744,
        1745,
        1748,
      ],
      weight: 0.77
    },
    {
      ids: [
        37,
        62,
        139,
        143,
        145,
        152,
        216,
        221,
        227,
        233,
        1098,
        1112,
        1185,
        1187,
        1188,
        1194,
        1200,
        1201,
        1379,
        1380,
        1384,
        1391,
        1434,
        1435,
        1439,
        1444,
        1518,
        1520,
        1561,
        1566,
      ],
      weight: 0.76
    },
    {
      ids: [
        34,
        36,
        63,
        65,
        137,
        138,
        142,
        144,
        151,
        217,
        218,
        222,
        228,
        231,
        438,
        441,
        443,
        1093,
        1099,
        1103,
        1117,
        1189,
        1199,
        1381,
        1382,
        1388,
        1389,
        1432,
        1433,
        1441,
        1445,
        1521,
        1534,
        1565,
        1572,
      ],
      weight: 0.75
    },
    {
      ids: [
        87,
        88,
        104,
        105,
        128,
        135,
        136,
        153,
        184,
        219,
        220,
        230,
        448,
        452,
        478,
        481,
        483,
        508,
        511,
        513,
        1091,
        1092,
        1100,
        1104,
        1106,
        1116,
        1385,
        1438,
        1535,
        1537,
        1570,
        1571,
        1740,
        1741,
        1743,
      ],
      weight: 0.74
    },
    {
      ids: [
        28,
        30,
        39,
        50,
        53,
        60,
        86,
        106,
        127,
        129,
        141,
        154,
        185,
        194,
        223,
        229,
        1088,
        1090,
        1096,
        1105,
        1108,
        1109,
        1390,
        1446,
        1536,
        1539,
        1540,
        1567,
        1569,
        1575,
      ],
      weight: 0.73
    },
    {
      ids: [
        25,
        35,
        55,
        64,
        84,
        108,
        120,
        126,
        130,
        132,
        175,
        186,
        192,
        193,
        1089,
        1095,
        1097,
        1107,
        1110,
        1113,
        1541,
        1574,
      ],
      weight: 0.72
    },
    {
      ids: [
        78,
        80,
        95,
        98,
        119,
        123,
        125,
        131,
        176,
        181,
        187,
        191,
        529,
        546,
        1094,
        1102,
        1111,
        1114,
        1538,
        1568,
      ],
      weight: 0.71
    },
    {
      ids: [
        75,
        100,
        117,
        118,
        122,
        124,
        177,
        178,
        182,
        188,
        439,
        440,
        442,
        454,
        457,
        530,
        545,
        1101,
        1115,
        1167,
        1168,
        1223,
        1224,
        1542,
        1573,
      ],
      weight: 0.7
    },
    {
      ids: [
        41,
        74,
        85,
        107,
        115,
        133,
        180,
        189,
        479,
        480,
        482,
        509,
        510,
        512,
        520,
        531,
        540,
        544,
        1165,
        1166,
        1171,
        1225,
        1226,
        1229,
        1738,
        1739,
        1742,
      ],
      weight: 0.69
    },
    {
      ids: [
        9,
        26,
        27,
        29,
        51,
        52,
        54,
        116,
        121,
        134,
        179,
        183,
        190,
        473,
        523,
        538,
        1163,
        1164,
        1170,
        1227,
        1228,
        1230,
      ],
      weight: 0.68
    },
    {
      ids: [
        11,
        49,
        66,
        79,
        96,
        471,
        525,
        535,
        1142,
        1143,
        1146,
        1147,
        1169,
        1231,
      ],
      weight: 0.67
    },
    {
      ids: [
        10,
        12,
        13,
        76,
        77,
        97,
        99,
        469,
        470,
        472,
        1133,
        1134,
        1135,
        1136,
        1137,
        1138,
        1139,
        1140,
        1141,
        1144,
        1145,
      ],
      weight: 0.66
    },
    {
      ids: [
        0,
        15,
        94,
        109,
        463,
        467,
        502,
        504,
        521,
        539,
      ],
      weight: 0.65
    },
    {
      ids: [
        3,
        5,
        444,
        445,
        446,
        455,
        456,
        458,
        461,
        484,
        485,
        503,
        515,
        516,
        522,
        524,
        536,
        537,
      ],
      weight: 0.64
    },
    {
      ids: [
        14,
        24,
        32,
        33,
        42,
        56,
        57,
        72,
        468,
        474,
        486,
        493,
        496,
        498,
        514,
        1734,
        1735,
        1737,
      ],
      weight: 0.63
    },
    {
      ids: [
        1,
        2,
        31,
        47,
        58,
        67,
        83,
        101,
        460,
        462,
      ],
      weight: 0.62
    },
    {
      ids: [
        4,
        16,
        81,
        82,
        92,
        102,
        103,
        110,
        459,
        477,
      ],
      weight: 0.61
    },
    {
      ids: [
        494,
        495,
        497,
        526,
        527,
        542,
        543,
      ],
      weight: 0.6
    },
    {
      ids: [
        22,
        475,
        528,
        541,
      ],
      weight: 0.59
    },
    {
      ids: [
        6,
        7,
        465,
        466,
      ],
      weight: 0.58
    },
    {
      ids: [
        8,
        17,
        44,
        73,
        339,
        341,
        342,
        343,
        345,
        389,
        390,
        391,
        464,
        476,
        490,
        491,
        492,
        499,
        500,
        501,
      ],
      weight: 0.57
    },
    {
      ids: [
        43,
        45,
        46,
        48,
        68,
        69,
        70,
        71,
        89,
        114,
      ],
      weight: 0.56
    },
    {
      ids: [
        90,
        91,
        93,
        111,
        112,
        113,
        368,
        534,
        1732,
        1733,
        1736,
      ],
      weight: 0.55
    },
    {
      ids: [
        23,
        364,
        366,
        367,
        532,
        533,
      ],
      weight: 0.54
    },
    {
      ids: [
        18,
        20,
        21,
        429,
        430,
        431,
      ],
      weight: 0.53
    },
    {
      ids: [
        19,
        427,
        505,
        506,
        507,
      ],
      weight: 0.52
    },
    {
      ids: [
        330,
        333,
        335,
        340,
        344,
        382,
        384,
        706,
        709,
      ],
      weight: 0.5
    },
    {
      ids: [
        379,
        388,
        398,
        401,
        407,
        643,
        646,
        648,
        652,
        682,
        684,
        688,
        711,
        730,
        733,
        735,
      ],
      weight: 0.49
    },
    {
      ids: [
        355,
        358,
        360,
        369,
        403,
        408,
        679,
        718,
        721,
        723,
      ],
      weight: 0.48
    },
    {
      ids: [
        365,
        418,
        421,
        423,
        428,
        659,
        662,
        664,
        668,
        669,
        694,
        697,
        699,
      ],
      weight: 0.47
    },
    {
      ids: [
        1728,
        1729,
        1731,
      ],
      weight: 0.45
    },
    {
      ids: [
        331,
        332,
        334,
        346,
        354,
        380,
        381,
        383,
        397,
        644,
        658,
        707,
        708,
        710,
        734,
      ],
      weight: 0.42
    },
    {
      ids: [
        356,
        357,
        359,
        370,
        399,
        400,
        402,
        409,
        417,
        645,
        647,
        680,
        681,
        683,
        689,
        719,
        720,
        722,
        731,
        732,
      ],
      weight: 0.41
    },
    {
      ids: [
        378,
        419,
        420,
        422,
        437,
        660,
        661,
        663,
        670,
        678,
        695,
        696,
        698,
      ],
      weight: 0.4
    },
    {
      ids: [
        1726,
        1727,
        1730,
      ],
      weight: 0.35
    },
    {
      ids: [
        336,
        337,
        338,
        347,
        352,
        385,
        386,
        387,
        395,
        649,
        650,
        656,
        712,
        713,
        714,
        737,
        738,
      ],
      weight: 0.34
    },
    {
      ids: [
        361,
        362,
        363,
        371,
        376,
        404,
        405,
        406,
        410,
        415,
        424,
        425,
        426,
        435,
        651,
        665,
        666,
        667,
        671,
        676,
        685,
        686,
        687,
        690,
        700,
        701,
        702,
        724,
        725,
        726,
        736,
      ],
      weight: 0.33
    },
    {
      ids: [
        348,
        349,
        350,
        351,
        353,
        392,
        393,
        394,
        396,
        414,
        416,
        632,
        634,
        635,
        636,
        653,
        654,
        655,
        657,
        691,
        715,
        716,
        717,
      ],
      weight: 0.26
    },
    {
      ids: [
        372,
        373,
        374,
        375,
        377,
        411,
        412,
        413,
        432,
        433,
        434,
        436,
        672,
        673,
        674,
        675,
        677,
        692,
        693,
        703,
        704,
        705,
        727,
        728,
        729,
        1722,
        1723,
        1725,
      ],
      weight: 0.25
    },
    {
      ids: [
        547,
        550,
        552,
        556,
        557,
        567,
        570,
        572,
        576,
        577,
        587,
        590,
        592,
        596,
        597,
        607,
        610,
        612,
        616,
        623,
        626,
        628,
        633,
        835,
        838,
        840,
        844,
        851,
        854,
        856,
        860,
        867,
        870,
        872,
        876,
        877,
        886,
        889,
        891,
        898,
        901,
        903,
        910,
        913,
        915,
        922,
        925,
        927,
      ],
      weight: 0.18
    },
    {
      ids: [
        1720,
        1721,
        1724,
      ],
      weight: 0.15
    },
    {
      ids: [
        548,
        549,
        551,
        558,
        566,
        568,
        569,
        571,
        578,
        586,
        588,
        589,
        591,
        598,
        606,
        608,
        609,
        611,
        622,
        624,
        625,
        627,
        642,
        836,
        837,
        839,
        845,
        852,
        853,
        855,
        866,
        868,
        869,
        871,
        878,
        885,
        887,
        888,
        890,
        899,
        900,
        902,
        911,
        912,
        914,
        923,
        924,
        926,
      ],
      weight: 0.11
    },
    {
      ids: [
        1716,
        1717,
        1719,
      ],
      weight: 0.07
    },
    {
      ids: [
        553,
        554,
        555,
        559,
        564,
        573,
        574,
        575,
        579,
        584,
        593,
        594,
        595,
        599,
        604,
        613,
        614,
        615,
        620,
        629,
        630,
        631,
        640,
        841,
        842,
        843,
        846,
        857,
        858,
        859,
        864,
        873,
        874,
        875,
        879,
        884,
        892,
        893,
        894,
        904,
        905,
        906,
        916,
        917,
        918,
        928,
        929,
        930,
      ],
      weight: 0.05
    },
    {
      ids: [
        1714,
        1715,
        1718,
      ],
      weight: 0.02
    },
    {
      ids: [
        560,
        561,
        562,
        563,
        565,
        580,
        581,
        582,
        583,
        585,
        600,
        601,
        602,
        603,
        605,
        617,
        618,
        619,
        621,
        637,
        638,
        639,
        641,
        824,
        825,
        826,
        828,
        847,
        848,
        849,
        850,
        861,
        862,
        863,
        865,
        880,
        881,
        882,
        883,
        895,
        896,
        897,
        907,
        908,
        909,
        919,
        920,
        921,
        1681,
        1682,
        1683,
        1684,
        1685,
        1686,
        1687,
        1688,
        1689,
        1690,
        1691,
        1692,
        1693,
        1694,
        1695,
        1696,
        1697,
        1698,
        1699,
        1700,
        1701,
        1702,
        1703,
        1704,
        1705,
        1706,
        1707,
        1708,
        1709,
        1710,
        1712,
        1713,
      ],
      weight: 0
    },
  ],
  centerId: 1746,
  name: "High Heel Height",
  min: 20,
  max: 100,
  value: 0,
  center: new Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};
export const HighHeelInsoleIndices: number[] = [
        1681,
        1682,
        1683,
        1684,
        1685,
        1686,
        1687,
        1688,
        1689,
        1690,
        1691,
        1692,
        1693,
        1694,
        1695,
        1696,
        1697,
        1698,
        1699,
        1700,
        1701,
        1702,
        1703,
        1704,
        1705,
        1706,
        1707,
        1708,
        1709,
        1710,
        1711,
        1712,
        1713,
        1714,
        1715,
        1716,
        1717,
        1718,
        1719,
        1720,
        1721,
        1722,
        1723,
        1724,
        1725,
        1726,
        1727,
        1728,
        1729,
        1730,
        1731,
        1732,
        1733,
        1734,
        1735,
        1736,
        1737,
        1738,
        1739,
        1740,
        1741,
        1742,
        1743,
        1744,
        1745,
        1746,
        1747,
        1748,
        1749,
        1750,
        1751,
        1752,
        1753,
        1754,
        1755,
        1756,
        1757,
        1758,
        1759,
        1760,
        1761,
        1762,
        1763,
        1764,
        1765,
        1766,
        1767,
        1768,
        1769,
        1770,
        1771,
        1772,
        1773]
      

export const HighHeelCurve = [1710,
        1714,
        1716,
        1720,
        1722,
        1726,
        1728,
        1732,
        1734,
        1738,
        1740,
        // 1744,
        1746,
        // 1750,
        1752,
        // 1756,
        1758,
        // 1762,
        1764,
        // 1768,
        1770]

export const HighHeel_heelCenterIndex: number = 1750;
export const HighHeelDragIndex = 1450;